"use client";

import React, { createContext, useContext, useState } from "react";

const MarketPlace = createContext();

export const useMarketPlace = () => {
  const context = useContext(MarketPlace);
  if (!context) {
    throw new Error("useMarketPlace must be used within a MarketPlaceProvider");
  }
  return context;
};

const defaultFilters = {
  category: "All",
  rarity: [],
  condition: [],
  type: [],
  priceRange: [0, 1000],
  available_to_buy: true,
  set: "",
  catalog_group_id: "",
  productType: "",
  tcg_category_id: "",
};

export const MarketPlaceProvider = ({ children }) => {
  const [productName, setProductName] = useState(null);

  // Marketplace browse state — kept here (rather than in Marketplace.jsx local
  // state) so filters/sort/search/page survive navigating to a card detail and
  // back, since the Marketplace component unmounts on that navigation.
  const [filters, setFilters] = useState(defaultFilters);
  const [sortBy, setSortBy] = useState("a-z");
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);

  /* WHICH SEARCH THE FACETS ABOVE BELONG TO. The `q` of the results page they
     were chosen on, or `null` when they were chosen while browsing.
     `Marketplace.jsx` reads it to tell a refinement of the search you are
     looking at apart from a leftover of the page you came from -- see the
     facet-scope effect there for the bug that needs.

     It lives beside `filters` rather than in a ref on the page because the
     page unmounts on the way to a card detail, and a ref would forget on the
     way back -- which would make returning to your own refined results look
     like a brand-new search and throw the refinement away. */
  const [facetScope, setFacetScope] = useState(null);

  return (
    <MarketPlace.Provider
      value={{
        productName,
        setProductName,
        filters,
        setFilters,
        sortBy,
        setSortBy,
        searchTerm,
        setSearchTerm,
        page,
        setPage,
        facetScope,
        setFacetScope,
      }}
    >
      {children}
    </MarketPlace.Provider>
  );
};
